const requireModule = require.context('.', false, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return
  
  modules[/^\.\/(.*)\.js/.exec(fileName)[1]] = {
    ...requireModule(fileName).default
  }

})

export default modules